import React from "react";
 // Custom CSS for styling
import "../pages/common.css"
const NumbersSection = () => {
  const stats = [
    {
      icon: "./images/icon1.png", // Replace with actual icon image path
      number: "100,000+",
      title: "Homes",
    },
    {
      icon: "./images/icon2.png", // Replace with actual icon image path
      number: "3,500+",
      title: "Expert Designers",
    },
    {
      icon: "./images/icon3.png", // Replace with actual icon image path
      number: "60+ cities",
      title: "We Work",
    },
  ];

  return (
    <section className="numbers-section">
      <div className="container text-center">
        <h2 className="numbers-title">We’ll let our numbers do the talking</h2>
        <div className="row mt-4">
          {stats.map((stat, index) => (
            <div className="col-md-4" key={index}>
              <div className="number-card">
                <img src={stat.icon} alt={stat.title} className="number-icon" />
                <h3 className="number">{stat.number}</h3>
                <p className="title">{stat.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NumbersSection;
